module.exports = __webpack_public_path__ + "img/a9_11.dcc03c66.jpg";